import React from 'react';
import { BtnAlternative } from '../../../share/buttons/Btn';
import customerdsc from '../../../../Assets/Image/png/customer-dsc.png';
import { HashLink, NavHashLink } from 'react-router-hash-link';

function CustomerDescription() {
	return (
		<div className='relative home__customer mt-24'>
			<span className='home__customer--shape'></span>
			{/* <div className="customer-description text-black text-6xl">&larr;</div> */}
			<div className='items-center flex text-justify p-[3rem] rounded-16  mb-[5.3rem] bg-white-dark relative '>
				<img src={customerdsc} alt={customerdsc} />
				<div className='mr-9'>
					<h2 className='primary-dark text-4xl font-bold mb-9'>
						بوت کمپ های کسب و کار
					</h2>
					<p className='text-cd primary-dark leading-extra-loose mb-[2.6rem]'>
						بوت‌کمپ‌ها در واقع دوره‌هایی هستند که به صورت مجازی و یا حقیقی
						برگزار می‌شوند تا افراد با کسب مهارت در آن‌ها، بتوانند خود در
						یک محیط کاری واقعی قرار دهند و برای ورود به بازار کار آماده
						شوند. با شرکت در بوت‌کمپ‌های تعاملی بوت‌وب به راحتی مهارت کسب
						کنید و با حجم زیادی از تجارب مفید، وارد بازار کار شوید.
					</p>
					<div className='flex flex-row justify-center items-center'>
						<HashLink key='bootcamps' to='/bootcamp#top'>
							<BtnAlternative
								className='px-[8rem] py-5 rounded-full'
								text='لیست بوت‌کمپ‌ها'
							/>
						</HashLink>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CustomerDescription;
